import React, { useState, useRef, useEffect } from 'react';
import '../pages/common.css';
import { useAuth } from '../contexts/AuthContext';

const LEVELS = [
  { level: 1, emoji: '🌱', label: 'Beginner',     desc: 'Level 1' },
  { level: 2, emoji: '🌿', label: 'Elementary',   desc: 'Level 2' },
  { level: 3, emoji: '🌻', label: 'Intermediate', desc: 'Level 3' },
  { level: 4, emoji: '⭐', label: 'Advanced',     desc: 'Level 4' },
  { level: 5, emoji: '🚀', label: 'Expert',       desc: 'Level 5' },
  { level: 6, emoji: '🏆', label: 'Master',       desc: 'Level 6' },
];

function useDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);
  return { open, setOpen, ref };
}

function Header({ onNavigate }) {
  const { isAuthenticated, username, logout, login } = useAuth();
  const levels = useDropdown();
  const user = useDropdown();

  const handleLevelClick = (level) => {
    if (!isAuthenticated) { alert('Please sign in to access levels'); return; }
    levels.setOpen(false);
    onNavigate && onNavigate(`level${level}`);
  };

  return (
    <header className="header">
      {/* ── Logo ── */}
      <div className="header-left">
        <div className="logo" onClick={() => onNavigate && onNavigate('home')} style={{ cursor: 'pointer' }}>
          <span className="logo-icon">🌱</span>
          <h1 className="app-title" style={{ display: 'inline-flex', alignItems: 'center', gap: 2, fontWeight: 900, fontSize: '2.8rem', letterSpacing: 2, margin: 0, lineHeight: 1, filter: 'drop-shadow(0 3px 6px rgba(0,0,0,0.35))' }}>
            {[
              { char: 'L', color: '#FFE94D' }, { char: 'e', color: '#FF8DC7' },
              { char: 'x', color: '#7FFFB2' }, { char: 'G', color: '#FFE94D' },
              { char: 'o', color: '#FF8DC7' }, { char: 'K', color: '#7FFFB2' },
              { char: 'i', color: '#FFE94D' }, { char: 'd', color: '#FF8DC7' },
              { char: 's', color: '#7FFFB2' },
            ].map(({ char, color }, i) => (
              <span key={i} style={{
                color, WebkitTextStroke: '2px rgba(0,0,0,0.25)', display: 'inline-block',
                transform: i % 2 === 0 ? 'translateY(-3px)' : 'translateY(3px)',
                textShadow: '2px 3px 0px rgba(0,0,0,0.35)',
                fontFamily: "'Arial Rounded MT Bold', 'Nunito', 'Comic Sans MS', sans-serif",
              }}>{char}</span>
            ))}
          </h1>
        </div>
      </div>

      {/* ── Nav items ── */}
      <nav className="header-nav">
        {/* Levels dropdown */}
        <div className="nav-item-wrap" ref={levels.ref}>
          <button className="nav-item nav-item--dropdown" onClick={() => levels.setOpen(o => !o)} aria-expanded={levels.open}>
            🎯 Levels <span className="nav-chevron">{levels.open ? '▲' : '▼'}</span>
          </button>
          {levels.open && (
            <div className="nav-dropdown">
              {LEVELS.map(({ level, emoji, label, desc }) => (
                <button key={level} className="nav-dropdown-item" onClick={() => handleLevelClick(level)}>
                  <span className="nav-dropdown-emoji">{emoji}</span>
                  <span className="nav-dropdown-text">
                    <span className="nav-dropdown-sub">{desc}</span>
                    <span className="nav-dropdown-main">{label}</span>
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* LexGoKids Agent */}
        <button className="nav-item" onClick={() => onNavigate && onNavigate('chattutor')}>
          🤖 LexGoKids Agent
        </button>

        {/* Dashboard (authenticated only) */}
        {isAuthenticated && (
          <button className="nav-item" onClick={() => onNavigate && onNavigate('dashboard')}>
            📊 My Dashboard
          </button>
        )}
      </nav>

      {/* ── Right: user menu or sign in ── */}
      <div className="header-right">
        {isAuthenticated ? (
          <div className="nav-item-wrap" ref={user.ref}>
            <button className="nav-item nav-item--user nav-item--dropdown" onClick={() => user.setOpen(o => !o)} aria-expanded={user.open}>
              👋 {username} <span className="nav-chevron">{user.open ? '▲' : '▼'}</span>
            </button>
            {user.open && (
              <div className="nav-dropdown nav-dropdown--right">
                <button className="nav-dropdown-item" onClick={() => { user.setOpen(false); logout(); }}>
                  <span className="nav-dropdown-emoji">🚪</span>
                  <span className="nav-dropdown-main">Sign Out</span>
                </button>
              </div>
            )}
          </div>
        ) : (
          <button className="login-btn" onClick={() => login()}>🔐 Sign In</button>
        )}
      </div>
    </header>
  );
}

export default Header;
